import React from 'react'

const Counter = () => {
  return (
    <>
      <div class="home-counter">
               <div class="container">
                  <div class="counter-wrap">
                     <div class="counter-item">
                        <span class="counter-no">
                           <span class="counter">80</span>K+
                        </span>
                        <span class="counter-desc">
                           SATISFIED CUSTOMER
                        </span>
                     </div>
                     <div class="counter-item">
                        <span class="counter-no">
                           <span class="counter">18</span>+
                        </span>
                        <span class="counter-desc">
                           ACTIVE MEMBERS
                        </span>
                     </div>
                     <div class="counter-item">
                        <span class="counter-no">
                           <span class="counter">220</span>+
                        </span>
                        <span class="counter-desc">
                           TOUR DESTINATION
                        </span>
                     </div>
                     <div class="counter-item">
                        <span class="counter-no">
                           <span class="counter">75</span>+
                        </span>
                        <span class="counter-desc">
                           TRAVEL GUIDES
                        </span>
                     </div>
                  </div>
               </div>
            </div>
    </>
  )
}

export default Counter
